/* Cadeau de bienvenue : champ code dans le cart drawer + ajout auto du produit offert.
 * Le code arrive dans cart.discount_codes via le champ (POST /cart/update.js {discount})
 * ou via le lien /discount/CODE (mail Klaviyo). Quand le code de bienvenue est présent
 * et qu'il y a au moins un autre article, le produit offert est ajouté (_welcome_gift),
 * sinon il est retiré. La gratuité vient de la réduction Shopify "Achetez X, obtenez Y".
 */
(function () {
  'use strict';

  var processing = false;
  var blockedSig = null;
  var debounceTimer = null;

  function config() {
    var el = document.querySelector('[data-welcome-gift]');
    if (!el) return null;
    return { el: el, code: (el.dataset.code || '').toUpperCase(), variantId: parseInt(el.dataset.variantId, 10) };
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function isGift(item) {
    return item.properties && item.properties._welcome_gift === 'true';
  }

  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return Promise.resolve();
    return fetch('/?sections=cart-drawer,cart-icon-bubble,cart-live-region-text')
      .then(function (r) { return r.json(); })
      .then(function (sections) { drawer.renderContents({ sections: sections }); });
  }

  function renderTags(c, cart, state) {
    var box = c.el.querySelector('[data-discount-tags]');
    if (!box) return;
    box.innerHTML = '';
    var codes = cart.discount_codes || [];
    c.el.classList.toggle('cart-discount--ok', codes.some(function (d) { return d.applicable; }));
    codes.forEach(function (d) {
      var tag = document.createElement('p');
      var isWelcome = (d.code || '').toUpperCase() === c.code;
      var neutral = !d.applicable && isWelcome && (state.pending || !state.others);
      tag.className = 'cart-discount__tag ' + (d.applicable ? 'cart-discount__tag--ok' : neutral ? '' : 'cart-discount__tag--off');
      if (d.applicable) {
        tag.innerHTML = '<svg class="cart-discount__check" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8"/><path d="M4.5 8.2l2.3 2.3 4.7-4.9"/></svg>';
        tag.appendChild(document.createTextNode(d.code));
      } else if (isWelcome && state.pending) {
        tag.textContent = 'Ajout de ton cadeau…';
      } else if (isWelcome && !state.others) {
        tag.textContent = d.code + ' enregistré, ajoute un cahier pour recevoir ton cadeau';
      } else {
        tag.textContent = d.code + '\u00a0: non valable pour ce panier';
      }
      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'cart-discount__remove';
      rm.setAttribute('data-discount-remove', '');
      rm.setAttribute('aria-label', 'Retirer le code ' + d.code);
      rm.textContent = '×';
      tag.appendChild(rm);
      box.appendChild(tag);
    });
  }

  function sync() {
    var c = config();
    if (!c || processing || !c.code || !c.variantId) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gift = null;
        var others = false;
        var sig = [];
        cart.items.forEach(function (item) {
          if (isGift(item)) gift = item;
          else { others = true; sig.push(item.variant_id + ':' + item.quantity); }
        });
        sig = sig.sort().join(',');
        var codeEntry = (cart.discount_codes || []).filter(function (d) { return (d.code || '').toUpperCase() === c.code; })[0];
        var hasCode = !!codeEntry;
        // Cadeau ajouté mais code refusé par Shopify (produit non éligible, client déjà venu…) : on le retire
        // et on ne réessaie que si le panier change, sinon le client paierait le cadeau
        var refused = gift && hasCode && !codeEntry.applicable;
        if (refused) blockedSig = sig;
        var want = hasCode && others && sig !== blockedSig;
        renderTags(c, cart, { pending: want && !gift, others: others });

        var action = null;
        if (refused || (!want && gift)) action = post('/cart/change.js', { id: gift.key, quantity: 0 });
        else if (want && !gift) action = post('/cart/add.js', { items: [{ id: c.variantId, quantity: 1, properties: { _welcome_gift: 'true' } }] });
        else if (gift && gift.quantity !== 1) action = post('/cart/change.js', { id: gift.key, quantity: 1 });
        if (!action) return;

        processing = true;
        return action.then(refreshDrawer).finally(function () { processing = false; });
      })
      .catch(function (err) { processing = false; console.error('[welcome-gift]', err); });
  }

  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, 150);
  }

  function setCodes(codes) {
    return post('/cart/update.js', { discount: codes })
      .then(refreshDrawer)
      .then(scheduleSync)
      .catch(function (err) { console.error('[welcome-gift]', err); });
  }

  function apply(c) {
    var input = c.el.querySelector('[data-discount-input]');
    var code = input && input.value.trim();
    if (code) setCodes(code);
  }

  document.addEventListener('click', function (e) {
    var c = config();
    if (!c || !c.el.contains(e.target)) return;
    if (e.target.closest('[data-discount-apply]')) { e.preventDefault(); apply(c); }
    if (e.target.closest('[data-discount-remove]')) { e.preventDefault(); setCodes(''); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches('[data-discount-input]')) return;
    e.preventDefault();
    var c = config();
    if (c) apply(c);
  });

  // Re-sync à chaque mise à jour du panier (Dawn pub/sub + tous les flows qui re-rendent le drawer)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSync);
  }
  (function patch(attempt) {
    var Drawer = window.customElements && customElements.get('cart-drawer');
    if (!Drawer) { if (attempt < 10) setTimeout(function () { patch(attempt + 1); }, 100); return; }
    if (Drawer.prototype._welcomeGiftPatched) return;
    var original = Drawer.prototype.renderContents;
    Drawer.prototype.renderContents = function () {
      var result = original.apply(this, arguments);
      scheduleSync();
      return result;
    };
    Drawer.prototype._welcomeGiftPatched = true;
  })(0);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
